const COUNTRY_OVERRIDES = {
  france: {
    LOCALE: "fr",
    CURRENCY: "EUR",
    DISPLAY_CURRENCY: "EUR",
  },
  poland: {
    LOCALE: "pl",
    CURRENCY: "PLN",
    DISPLAY_CURRENCY: "PLN",
  }
};

function getCountryKey() {
  if (typeof window === "undefined") return null;
  const url = new URL(window.location.href);

  // ?country=france
  const q = url.searchParams.get("country");
  if (q) return q.toLowerCase();

  // albo /france jako pierwszy segment
  const first = url.pathname.split("/").filter(Boolean)[0];
  return first ? first.toLowerCase() : null;
}

const country = getCountryKey();
const o = (country && COUNTRY_OVERRIDES[country]) ? COUNTRY_OVERRIDES[country] : {};

export let BASE_URL = process.env.REACT_APP_BASE_URL;
export let BASE_TRANSLATION_APP_URL = process.env.REACT_APP_TRANSLATIONS_APP_BASE_URL;

export let CURRENCY = o.CURRENCY || process.env.REACT_APP_CURRENCY;
export let DISPLAY_CURRENCY = o.DISPLAY_CURRENCY || process.env.REACT_APP_DISPLAY_CURRENCY;
export let LOCALE = o.LOCALE || process.env.REACT_APP_LOCALE;

export let STATICS_URL = `${BASE_URL}files/shared/`;
export const getStatics = (name) => `${STATICS_URL}${name}`;
